<script>
  export let position = 'left',
    onClick = () => {},
    icon = '';
</script>

<button class="control control-{position}" on:click|preventDefault={onClick}>
  <i class="icon-{icon}" />
</button>
